import { Info } from "lucide-react";

export const MissionDescription = ({ description }) => {
  if (!description || description === "Mission details pending") {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-2">
        <Info className="w-4 h-4 text-cosmic-blue" strokeWidth={1.5} />
        <h3 className="font-heading font-semibold text-white uppercase tracking-wider text-sm">
          Mission Details
        </h3>
      </div>
      <p className="text-slate-400 leading-relaxed">{description}</p>
    </div>
  );
};
